const angular = require('angular');

const VIEWMORE_ENABLE_HEIGHT = 72;

class ViewMoreController {
    constructor($sce, $timeout) {
        this.$sce = $sce;
        this.$timeout = $timeout;
    }

    $onInit() {

        this.fullTextValue = this.$sce.trustAsHtml(this.fullText);

        if (!this.isShowHideMode) {
            if (this.charCount < this.fullText.length) {
                this.isExpanded = false;
                this.displayText = this.$sce.trustAsHtml(`${this.fullText.slice(0, this.charCount)} ...`);
            }
        } else {
            // show hide mode
            this.isExpanded = false;
            this.showMore = true;
            this.$timeout(() => {
                const actualHeight = angular.element('.js-fulltext-container')[0].scrollHeight;
                if (actualHeight <= VIEWMORE_ENABLE_HEIGHT) {
                    this.showMore = false;
                }
            });
        }
    }
}

const viewMoreComponentDefinition = {
    bindings: {
        charCount: '=',
        isShowHideMode: '=',
        customCollapsedClass: '@',
        fullText: '=',
        customExpandoClass: '@',
    },
    controller: ['$sce', '$timeout', ViewMoreController],
    template: require('./viewmore.component.html').trim(),
};

module.exports = {
    ViewMoreController,
    viewMoreComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/viewmore/viewmore.component.js